import React from 'react';
import './FaceDelete.scss';
import { connect } from 'react-redux';
import PageHelper from 'Flow2/components/Article/Helpers/PageHelper';
import CustomPopUp from 'Flow2/components/Article/Utilities/PopUp/PopUp';
import { injectIntl } from 'react-intl';
import { faSmile } from '@fortawesome/free-solid-svg-icons';
import * as actions from "store/actions/index";
import Spinner from 'Flow2/components/UI/Spinner/Spinner';

class FaceDelete extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            requiredObj: {},
            data: [],
            current: {}
        }
    }

    getBodyClasses = () => "custom-body custom-mt10";

    onCloseBtnClick = () => {
        const { faceDelete } = this.props.faceObjects;
        this.props.updatePopUpObjects({
            [`${this.props.subObjName}`]: { ...faceDelete, showOverlay: false },
            showPreview: false
        });

        if (this.props.cancelCallback) this.props.cancelCallback();
    }


    onSelectFace = (subject) => {
        this.initData(subject);
    }


    onChangeHandler = (e) => {
        const { current } = this.state;
        this.setState({ current: { ...current, subject: e.target.value } });
    }

    onConfirmClick = () => {
        const { current } = this.state;
        if (current && current.subject) {
            this.props.deleteSubject({ name: current.subject })
        }

        this.onCloseBtnClick();
    }

    showDeleteForm = () => {
        const { current } = this.state;
        return (
            <div className="facedelete-formgroup">
                <p>
                    {this.props.intl.formatMessage({ id: "data.face.delete.message" }, { subject: current.subject })}
                </p>
            </div>
        )
    }

    displayPopUp = () => {
        return (<CustomPopUp titleIntl={this.props.titleIntl}
            contentItems={this.state.data} requiredObj={this.state.requiredObj} customIcon={faSmile}
            mainObj={this.props.faceObjects} mainObjName={this.props.mainObjName} subObjName={this.props.subObjName}
            updatePopUpObjects={this.props.updateFaceObjects} confirmCallback={this.onConfirmClick}>
            {this.showDeleteForm()}
        </CustomPopUp>)
    }

    componentDidUpdate(prev) {
        if (this.props.current != prev.current) {
            this.setState({ current: this.props.current });
        }
    }

    componentDidMount() {
        this.setState({ current: this.props.current });
    }

    componentWillUnmount() {
        this.onCloseBtnClick();
    }

    render() {
        return (
            <div className="FaceDelete" onClick={PageHelper.onPopUpClick}>
                {this.props.mainObj[`${this.props.subObjName}`].showOverlay ?
                    <div className="custom-overlay">
                        <div className="custom-preview">
                            {this.props.loading ?
                                <div className="custom-spinner-overlay"><Spinner /></div>
                                : <div />}
                            {this.displayPopUp()}
                        </div>
                    </div> : null}
            </div>
        );
    }
}

const mapStateToprops = (state) => ({
    faceObjects: state.face.faceObjects,
    loading: state.face.loading
})
const mapDispatchToProps = (dispatch) => ({
    updateFaceObjects: (obj) => dispatch(actions.updateFaceObjects(obj)),
    deleteSubject: (obj) => dispatch(actions.deleteSubject(obj))
})

export default connect(mapStateToprops, mapDispatchToProps)(injectIntl(FaceDelete));